import React from 'react';
import { t } from '@sm/intl';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import useFeatureSetStyles from './useStyles';
import EnabledCheckMark from '~app/pages/Pricing/components/PricingFooter/components/EnabledCheckMark';
import COPY from '~pricing/experiments/grow_2792_pnp_refresh_v1/copy/ippmCopy';
import { PAID_TBYB_FEATURES_COPY_MAP } from '../../../constants';
import DisabledCheckMark from '~app/pages/Pricing/components/PricingFooter/components/DisabledCheckMark';
import { PaidFeatures as PaidFeaturesType } from '../../../types';
import { Packages } from '~shared/constants/pricing';

export default function PaidFeatures({
  paidFeatures,
  packageName,
}: {
  paidFeatures: PaidFeaturesType[];
  packageName: Packages;
}): React.ReactElement {
  const { Features, FeatureList, FeatureItem } = useFeatureSetStyles();

  return (
    <Box className={Features}>
      <Typography color="dark" variant="bodySm" weight="medium">
        {t(COPY.PAID_FEATURES)}
      </Typography>
      <ul className={FeatureList}>
        {paidFeatures.map(feature => {
          const mappedFeature = PAID_TBYB_FEATURES_COPY_MAP[feature];

          return (
            <li key={`PaidFeature-${feature}`} className={FeatureItem}>
              {mappedFeature.includedPackage?.includes(packageName) ? <EnabledCheckMark /> : <DisabledCheckMark />}
              <Typography color="dark" variant="bodySm">
                {t(mappedFeature?.label)}
              </Typography>
            </li>
          );
        })}
      </ul>
    </Box>
  );
}
